import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styles from './card.scss';
import { cursorDataProps } from '../../../../props/feed-prop-types';

const Card = forwardRef(
  ({ cursorData, children, className, ...options }, ref) => {
    const classNames = () => {
      const a = [styles.feedEntry, styles.card, className];
      return a;
    };

    return (
      <div
        className={classNames().join(' ')}
        data-testid="web-feed-entry"
        ref={ref}
        {...options}
      >
        {children}
      </div>
    );
  }
);

Card.propTypes = {
  children: PropTypes.node.isRequired,
  cursorData: cursorDataProps.isRequired,
  className: PropTypes.string
};

Card.defaultProps = {
  className: null
};

export default Card;
